import { DatePipe, DecimalPipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import * as int from './core/models';
import { CustomerProposalComponent } from './module/home/customer-proposal/customer-proposal.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MetaReducer, StoreModule } from '@ngrx/store';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { CookieService } from 'ngx-cookie-service';
import { ToastrModule } from 'ngx-toastr';
import { AppConfig } from './app.config';
import { HttpErrorInterceptor } from './core/interceptors/error.interceptor';
import { InterceptorService } from './core/interceptors/interceptor.service';
import { ExcelService } from './core/services/excel.service';
import { MarineCustomerProposalComponent } from './module/Marine/customer-proposal/marine-customer-proposal/marine-customer-proposal.component';
import { MoCustomerProposalComponent } from './module/MarineOpen/mo-customer-proposal/mo-customer-proposal.component';
import { PaymentRedirectionComponent } from './module/home/payment-redirection/payment-redirection.component';
import { MsCustomerProposalComponent } from './module/marine-stop/ms-customer-proposal/ms-customer-proposal.component';
import { UwmailaccessComponent } from './module/uwmailaccess/uwmailaccess.component';
import { WcCustomerProposalComponent } from './module/wc/wc-customer-proposal/wc-customer-proposal.component';
import { RedirectPdfurlComponent } from './shared/components/redirect-pdf-url/redirect-pdf-url.component';
import { RedirectTinyUrlComponent } from './shared/components/redirect-tiny-url/redirect-tiny-url.component';
import { SharedModule } from './shared/shared.module';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { DataTablesModule } from 'angular-datatables';
import { MotorProposalCustomerViewComponent } from 'src/app/partner-portal/module/motor/motordetails/motor-proposal-customer-view/motor-proposal-customer-view.component';
import { PerformanceInterceptor } from './core/interceptors/timer.interceptor';
import { EndorsementCustomerViewComponent } from './partner-portal/module/endorsement/endorsement-customer-view/endorsement-customer-view.component';
// import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OtpVerificationCancellationComponent } from './otp-verification-cancellation/otp-verification-cancellation.component';

import { reducers } from './store/reducers/index';
// const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];
const metaReducers: Array<MetaReducer<any, any>> = [];

@NgModule({
    declarations: [
        AppComponent,
        CustomerProposalComponent,
        PaymentRedirectionComponent,
        UwmailaccessComponent,
        MarineCustomerProposalComponent,
        WcCustomerProposalComponent,
        MoCustomerProposalComponent,
        MsCustomerProposalComponent,
        RedirectTinyUrlComponent,
        RedirectPdfurlComponent,
        // NewHeaderComponent, already imported and exported in sharedModule
        MotorProposalCustomerViewComponent,
        EndorsementCustomerViewComponent,
        OtpVerificationCancellationComponent
    ],
    bootstrap: [AppComponent], imports: [RouterModule, BrowserModule, BrowserAnimationsModule, ToastrModule.forRoot(), SharedModule, Ng2SearchPipeModule, DataTablesModule,
        AutocompleteLibModule, AppRoutingModule, MatListModule, MatMenuModule, MatRadioModule, MatSelectModule, MatStepperModule, MatTableModule,
        MatCheckboxModule, MatChipsModule, MatNativeDateModule, MatOptionModule, MatDialogModule, MatDividerModule, MatFormFieldModule, MatGridListModule, MatInputModule, MatAutocompleteModule, MatExpansionModule, MatTooltipModule, FormsModule, MatIconModule, MatButtonModule, MatSlideToggleModule, ReactiveFormsModule,
        StoreModule.forRoot(reducers, { metaReducers })], providers: [DatePipe, ExcelService, DecimalPipe, CookieService, MatDatepickerModule,
            {
                provide: HTTP_INTERCEPTORS,
                useClass: int.LoaderInterceptorService,
                multi: true
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: HttpErrorInterceptor,
                multi: true
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: InterceptorService,
                multi: true
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: PerformanceInterceptor,
                multi: true
            },
            AppConfig,
            // { provide: APP_INITIALIZER, useFactory: (config: AppConfig) => () => config.load(), deps: [AppConfig], multi: true },
            // { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true }
            MatDialog, provideHttpClient(withInterceptorsFromDi(), withXsrfConfiguration({ cookieName: 'XSRF-TOKEN', headerName: 'X-XSRF-TOKEN' }))]
})
export class AppModule { }
